export const DEDUCTIBLE_OLD_FOUR_THOUSAND_VALUE = "1";
export const DEDUCTIBLE_OLD_SIX_THOUSAND_VALUE = "5";
export const DEDUCTIBLE_OLD_EIGHT_THOUSAND_VALUE = "2";
export const DEDUCTIBLE_OLD_TWELVE_THOUSAND_VALUE = "6";
export const DEDUCTIBLE_OLD_TWELVE_THOUSAND_VALUE_CARAVAN = "7";
export const DEDUCTIBLE_OLD_SIXTEEN_THOUSAND_VALUE = "3";
export const DEDUCTIBLE_OLD_THIRTY_THOUSAND_VALUE = "4";
